import '../../lib/ui-grid.js'
import Alert from './Alert'
import AlertCountService from './AlertCountService'
import AlertService from './AlertService'
import AlertsManagementController from './AlertsManagementController'
import ConfirmDeleteModalController from './ConfirmDeleteModalController'
import angular from 'angular'
import register from '../util/register'

var alertsManagement = angular.module(
  'app.alertsManagement',
  [
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.resizeColumns',
    'ui.grid.moveColumns',
    'ui.grid.pagination',
    'ui.grid.expandable'
  ])

register('app.alertsManagement')
  .service('AlertService', AlertService)
  .service('AlertCountService', AlertCountService)
  .controller('AlertsManagementController', AlertsManagementController)
  .controller('ConfirmDeleteModalController', ConfirmDeleteModalController)
  .factory('Alert', Alert.factory)

alertsManagement.run()
